import { render, staticRenderFns } from "./SSOButton.vue?vue&type=template&id=d7d33d1e&scoped=true&"
import script from "./SSOButton.vue?vue&type=script&lang=js&"
export * from "./SSOButton.vue?vue&type=script&lang=js&"
import style0 from "./SSOButton.vue?vue&type=style&index=0&id=d7d33d1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d33d1e",
  null
  
)

export default component.exports